import React from 'react';
import {
  PHARMACY_BANK_CONNECTION_PERMISSION,
  PHARMACY_EINVOICE_CONNECTION_PERMISSION,
} from 'pages/PharmacyConfiguration/utils/constants';

const PharmacyBankConnectionPage = React.lazy(() => import('pages/PharmacyConfiguration/PharmacyBankConnectionPage'));
const PharmacyEinvoiceConnectionPage = React.lazy(() => import('pages/PharmacyConfiguration/PharmacyEinvoiceConnectionPage'));

const pharmacyConfigurationRoute = [
  {
    path: '/pharmacy-bank-connections',
    exact: true,
    name: 'Ngân hàng nhận tiền nhà thuốc',
    function: PHARMACY_BANK_CONNECTION_PERMISSION.VIEW,
    component: PharmacyBankConnectionPage,
  },
  {
    path: '/pharmacy-einvoice-connections',
    exact: true,
    name: 'Kết nối xuất hóa đơn nhà thuốc',
    function: PHARMACY_EINVOICE_CONNECTION_PERMISSION.VIEW,
    component: PharmacyEinvoiceConnectionPage,
  },
];

export default pharmacyConfigurationRoute;
